module.exports = __webpack_public_path__ + "fonts/Roboto-500-latin-ext47.a6323dd.woff2";